// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-shell {
  display: grid;
  gap: 1.25rem;
  padding: 0.5rem 0;
}
.details-shell header {
  display: grid;
  gap: 0.55rem;
}
.details-shell h1,
.details-shell h2 {
  margin: 0;
  line-height: 1.2;
}
.details-shell h1 {
  font-size: 1.75rem;
  font-weight: 700;
}
.details-shell h2 {
  font-size: 1.2rem;
  font-weight: 700;
}
.details-shell p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #5b6774;
}
.details-shell nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 0.8rem;
  padding-top: 0.2rem;
}
.details-shell nav a {
  color: #0f6075;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.3;
  min-height: 2.3rem;
  display: inline-flex;
  align-items: center;
}

.meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.8rem 1rem;
  background: #fff;
  border: 1px solid #d4dde2;
  border-radius: 8px;
  padding: 1rem;
}
.meta div {
  font-size: 0.93rem;
  line-height: 1.45;
}

.structure {
  background: #fff;
  border: 1px solid #d4dde2;
  border-radius: 8px;
  padding: 1rem;
  overflow: auto;
}
.structure table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
}
.structure table th,
.structure table td {
  text-align: left;
  border-bottom: 1px solid #e4ebf0;
  padding: 0.75rem 0.7rem;
  vertical-align: top;
  line-height: 1.45;
}
.structure table th {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #f4f8fa;
  white-space: nowrap;
}
.structure table td {
  font-size: 0.9rem;
}

.not-found {
  display: grid;
  gap: 0.75rem;
}
.not-found h1 {
  margin: 0;
  font-size: 1.45rem;
  line-height: 1.2;
}
.not-found a {
  color: #0f6075;
  text-decoration: none;
  font-weight: 600;
  min-height: 2.4rem;
  width: fit-content;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 720px) {
  .details-shell {
    gap: 1rem;
  }
  .meta,
  .structure {
    padding: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/dynamic-forms/dynamic-form-details-page/dynamic-form-details-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,YAAA;AACJ;AAEE;;EAEE,SAAA;EACA,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,gBAAA;AADJ;AAIE;EACE,iBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAHJ;AAME;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAJN;;AASA;EACE,aAAA;EACA,2DAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AANF;AAQE;EACE,kBAAA;EACA,iBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAPF;AASE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AASI;;EAEE,gBAAA;EACA,gCAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAPN;AAUI;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AARN;AAWI;EACE,iBAAA;AATN;;AAcA;EACE,aAAA;EACA,YAAA;AAXF;AAaE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE;IACE,SAAA;EAbF;EAgBA;;IAEE,gBAAA;EAdF;AACF","sourcesContent":[".details-shell {\n  display: grid;\n  gap: 1.25rem;\n  padding: 0.5rem 0;\n\n  header {\n    display: grid;\n    gap: 0.55rem;\n  }\n\n  h1,\n  h2 {\n    margin: 0;\n    line-height: 1.2;\n  }\n\n  h1 {\n    font-size: 1.75rem;\n    font-weight: 700;\n  }\n\n  h2 {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.95rem;\n    line-height: 1.5;\n    color: #5b6774;\n  }\n\n  nav {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.65rem 0.8rem;\n    padding-top: 0.2rem;\n\n    a {\n      color: #0f6075;\n      text-decoration: none;\n      font-weight: 600;\n      font-size: 0.92rem;\n      line-height: 1.3;\n      min-height: 2.3rem;\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n}\n\n.meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 0.8rem 1rem;\n  background: #fff;\n  border: 1px solid #d4dde2;\n  border-radius: 8px;\n  padding: 1rem;\n\n  div {\n    font-size: 0.93rem;\n    line-height: 1.45;\n  }\n}\n\n.structure {\n  background: #fff;\n  border: 1px solid #d4dde2;\n  border-radius: 8px;\n  padding: 1rem;\n  overflow: auto;\n\n  table {\n    width: 100%;\n    min-width: 680px;\n    border-collapse: collapse;\n\n    th,\n    td {\n      text-align: left;\n      border-bottom: 1px solid #e4ebf0;\n      padding: 0.75rem 0.7rem;\n      vertical-align: top;\n      line-height: 1.45;\n    }\n\n    th {\n      font-size: 0.78rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      background: #f4f8fa;\n      white-space: nowrap;\n    }\n\n    td {\n      font-size: 0.9rem;\n    }\n  }\n}\n\n.not-found {\n  display: grid;\n  gap: 0.75rem;\n\n  h1 {\n    margin: 0;\n    font-size: 1.45rem;\n    line-height: 1.2;\n  }\n\n  a {\n    color: #0f6075;\n    text-decoration: none;\n    font-weight: 600;\n    min-height: 2.4rem;\n    width: fit-content;\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n@media (max-width: 720px) {\n  .details-shell {\n    gap: 1rem;\n  }\n\n  .meta,\n  .structure {\n    padding: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
